module.exports = __webpack_public_path__ + "img/4S.a1c2b1fe.png";